if (document.querySelector('#inquiryFormRegister')) {
    const event1Field = document.querySelector('.js-alt-event-selection-1');
    const event2Field = document.querySelector('.js-alt-event-selection-2');
    const addEventButton = document.querySelector('.js-additional-workshop-add-button');

    const invoiceRecipientField = document.querySelector('#inquiryFormRegister-invoiceRecipient');
    const invoiceRecipientStreet = document.querySelector('#inquiryFormRegister-invoiceStreet');
    const invoiceRecipientPostCode = document.querySelector('#inquiryFormRegister-invoicePostCode');
    const invoiceRecipientCity = document.querySelector('#inquiryFormRegister-invoiceCity');

    const employeeCheckbox = document.querySelector('#inquiryFormRegister-employeeOfProJuventute');
    const costCenterSection = document.querySelector('.input--cost-center-for-employee');
    const costCenterSelectField = document.querySelector('#inquiryFormRegister-costCenter');

    // on the server side these fields are not required, since it makes it much easier
    // for use to just hide them on internal forms if a costCenter has been selected
    // Otherwise this would require some semi-complex validation
    manageRequireAttribute([invoiceRecipientStreet, invoiceRecipientPostCode, invoiceRecipientCity], true);

    const seminarForm = document.querySelector('.seminar-form');

    // add event button is absent on pages with workshops, since
    // the two event fields are used for workshops and are mandatory.
    if (addEventButton) {
        let event1Value = event1Field.querySelector('select').value;
        const event2Value = event2Field.querySelector('select').value;

        event1Field.addEventListener('change', (e) => {
            event1Value = e.currentTarget.value;
            if (event1Value !== '') {
                addEventButton.parentNode.setAttribute('style', 'display: block');
            }

            if (seminarForm && seminarForm.classList.contains('type--fachtagung')) {
                addEventButton.parentNode.setAttribute('style', 'display: none');
            }
        });

        if (event1Value === '') {
            event1Field.setAttribute('style', 'display: none');
        } else if (seminarForm && seminarForm.classList.contains('type--fachtagung')) {
            addEventButton.parentNode.setAttribute('style', 'display: none');
        }

        if (event1Value !== '' && event2Value !== '') {
            addEventButton.parentNode.setAttribute('style', 'display: none');
        }

        if (event2Value === '' && seminarForm && !seminarForm.classList.contains('type--fachtagung')) {
            event2Field.setAttribute('style', 'display: none');
        }

        addEventButton.addEventListener('click', () => {
            if (event1Value === '') {
                event1Field.setAttribute('style', 'display: block');
            } else if (event2Value === '' && seminarForm && !seminarForm.classList.contains('type--fachtagung')) {
                event2Field.setAttribute('style', 'display: block');
            }

            addEventButton.parentNode.setAttribute('style', 'display: none');
        });
    } else {
        const attendanceField = document.querySelector('#inquiryFormRegister-attendance');
        const eventsContainer = document.querySelector('.js-additional-events-container');

        if (attendanceField) {
            const onChange = () => {
                if (eventsContainer) {
                    if (attendanceField.value !== 'presence') {
                        eventsContainer.style.display = 'none';
                        event1Field.removeAttribute('required');
                        event2Field.removeAttribute('required');
                    } else {
                        eventsContainer.style.display = 'block';
                        event1Field.querySelector('select').setAttribute('required', true);
                        event2Field.querySelector('select').setAttribute('required', true);
                    }
                }
            };
            onChange();

            attendanceField.addEventListener('change', onChange);
        } else if (eventsContainer) {
            eventsContainer.style.display = 'block';
            event1Field.querySelector('select').setAttribute('required', true);
            event2Field.querySelector('select').setAttribute('required', true);
        }
    }

    // auto-prefill invoice fields for internal events
    // by adding a select field
    if (document.querySelector('#inquiryFormRegister-facility')) {
        const facilitySelectField = document.querySelector('#inquiryFormRegister-facility');
        const constCenterSelectField = document.querySelector('#inquiryFormRegister-costCenter');
        const invoiceRecipientField = document.querySelector('#inquiryFormRegister-invoiceRecipient');

        if (constCenterSelectField.value === '' && facilitySelectField.value !== 'projuventute') {
            facilityIsNotProjuventute();
        } else {
            facilityIsProjuventute();
        }

        constCenterSelectField.addEventListener('change', function () {
            const constCenterLabel = constCenterSelectField.options[constCenterSelectField.selectedIndex].innerHTML;
            invoiceRecipientField.value = constCenterLabel;
        });

        facilitySelectField.addEventListener('change', (e) => {
            if (e.currentTarget.value === 'projuventute') {
                facilityIsProjuventute();
            } else {
                invoiceRecipientField.value = '';
                facilityIsNotProjuventute();
            }
        });

        function facilityIsProjuventute() {
            constCenterSelectField.style.display = 'block';
            manageRequireAttribute([invoiceRecipientStreet, invoiceRecipientPostCode, invoiceRecipientCity], false);
            manageReadOnlyAttribute(
                [invoiceRecipientField, invoiceRecipientStreet, invoiceRecipientPostCode, invoiceRecipientCity],
                true
            );
            hideFieldIncludingParent([invoiceRecipientStreet, invoiceRecipientPostCode, invoiceRecipientCity], true);
        }

        function facilityIsNotProjuventute() {
            constCenterSelectField.style.display = 'none';
            manageRequireAttribute([invoiceRecipientStreet, invoiceRecipientPostCode, invoiceRecipientCity], true);
            manageReadOnlyAttribute(
                [invoiceRecipientField, invoiceRecipientStreet, invoiceRecipientPostCode, invoiceRecipientCity],
                false
            );
            hideFieldIncludingParent([invoiceRecipientStreet, invoiceRecipientPostCode, invoiceRecipientCity], false);
        }
    }

    if (seminarForm && seminarForm.classList.contains('type--fachtagung')) {
        event2Field.style.display = 'none';
        event2Field.querySelector('select').removeAttribute('required');
    }

    if (employeeCheckbox) {
        employeeCheckbox.addEventListener('change', toggleCostCenterFieldsForEmployeeCheckbox);

        toggleCostCenterFieldsForEmployeeCheckbox();
    }

    function toggleCostCenterFieldsForEmployeeCheckbox() {
        const constCenterSelectField = document.querySelector('#inquiryFormRegister-costCenter');
        if (employeeCheckbox.checked) {
            costCenterSection.style.display = 'block';
            manageRequireAttributeInvoice([costCenterSelectField], true);

            // reset invoice fields
            invoiceRecipientField.value = '';
            invoiceRecipientStreet.value = '';
            invoiceRecipientPostCode.value = '';
            invoiceRecipientCity.value = '';

            manageDisabledAttribute([invoiceRecipientStreet, invoiceRecipientPostCode, invoiceRecipientCity], true);
            manageRequireAttributeInvoice(
                [invoiceRecipientField, invoiceRecipientStreet, invoiceRecipientPostCode, invoiceRecipientCity],
                false
            );

            constCenterSelectField.addEventListener('change', function () {
                const constCenterLabel = constCenterSelectField.options[constCenterSelectField.selectedIndex].innerHTML;
                invoiceRecipientField.value = constCenterLabel;
                manageReadOnlyAttribute([invoiceRecipientField], true);
            });
        } else {
            costCenterSection.style.display = 'none';
            manageRequireAttributeInvoice([costCenterSelectField], false);

            manageDisabledAttribute([invoiceRecipientStreet, invoiceRecipientPostCode, invoiceRecipientCity], false);
            manageRequireAttributeInvoice(
                [invoiceRecipientField, invoiceRecipientStreet, invoiceRecipientPostCode, invoiceRecipientCity],
                true
            );

            invoiceRecipientField.value = '';
            manageReadOnlyAttribute([invoiceRecipientField], false);
        }
    }

    function manageDisabledAttribute(fields, value) {
        fields.forEach((field) => {
            if (value) {
                field.setAttribute('disabled', true);
                field.classList.add('input-disabled');
            } else {
                field.removeAttribute('disabled');
                field.classList.remove('input-disabled');
            }
        });
    }

    function manageRequireAttributeInvoice(fields, require) {
        fields.forEach((field) => {
            if (require) {
                field.required = true;
            } else {
                field.required = false;
            }
        });
    }

    function manageReadOnlyAttribute(fields, value) {
        if (value === true) {
            fields.forEach((field) => field.setAttribute('readOnly', value));
        } else {
            fields.forEach((field) => field.removeAttribute('readOnly'));
        }
    }

    function hideFieldIncludingParent(fields, hide) {
        if (hide === true) {
            fields.forEach((field) => {
                field.value = '';
                field.parentNode.style.display = 'none';
            });
        } else {
            fields.forEach((field) => {
                field.parentNode.style.display = 'block';
            });
        }
    }

    function manageRequireAttribute(fields, require) {
        fields.forEach((field) => {
            if (field) {
                field.required = require;
            }
        });
    }
}
